// Configuración centralizada de categorías y etiquetas para el proyecto Diegoncurso

export const categoriasConfig = {
  'videojuegos': {
    nombre: 'Videojuegos',
    color: '#b39ddb', // Morado pastel
    etiquetas: ['Pokémon', 'The Legend of Zelda', 'Kingdom Hearts', 'Mario', 'Zelda', 'Final Fantasy', 'Dragon Quest', 'Minecraft', 'Call of Duty', 'FIFA', 'Overwatch', 'League of Legends', 'Otro']
  },
  'deportes': {
    nombre: 'Deportes',
    color: '#80cbc4', // Verde agua pastel
    etiquetas: ['Fútbol', 'Baloncesto', 'Tenis', 'Fórmula 1', 'Natación', 'Atletismo', 'Rugby', 'Béisbol', 'Golf', 'Boxeo', 'Otro']
  },
  'cine': {
    nombre: 'Cine',
    color: '#ffe082', // Amarillo pastel
    etiquetas: ['Marvel', 'DC', 'Star Wars', 'Harry Potter', 'Pixar', 'Disney', 'Anime', 'Terror', 'Ciencia Ficción', 'Comedia', 'Series', 'Reality Shows', 'Documentales', 'Drama', 'Animación', 'Telenovelas', 'Programas', 'Actores', 'Otro']
  },
  'arte': {
    nombre: 'Arte',
    color: '#f48fb1', // Rosa pastel
    etiquetas: ['Pintura', 'Escultura', 'Música', 'Teatro', 'Fotografía', 'Arquitectura', 'Danza', 'Autores', 'Movimientos', 'Rock', 'Pop', 'Jazz', 'Clásica', 'Electrónica', 'Hip Hop', 'Reggaeton', 'Salsa', 'Flamenco', 'Country', 'Clásicos', 'Fantasía', 'Misterio', 'Romance', 'Aventura', 'Poemas', 'Premios', 'Géneros', 'Otro']
  },
  'ciencia': {
    nombre: 'Ciencia',
    color: '#90caf9', // Azul pastel
    etiquetas: ['Física', 'Química', 'Biología', 'Matemáticas', 'Astronomía', 'Tecnología', 'Medicina', 'Geología', 'Ecología', 'Genética', 'Otro']
  },
  'cultura': {
    nombre: 'Cultura',
    color: '#c5e1a5', // Verde pastel
    etiquetas: [
      'Historia', 'Mitología', 'Filosofía', 'Antropología', 'Literatura universal', 'Tradiciones', 'Costumbres', 'Folclore', 'Idiomas', 'Religiones', 'Patrimonio', 'Museos', 'Sociedad', 'Cultura popular', 'Historia contemporánea', 'Civilizaciones', 'Otro']
  }
};

const collatorEs = new Intl.Collator('es', { sensitivity: 'base' });

// Función para obtener todas las categorías como un array
export const getCategorias = () => {
  return Object.keys(categoriasConfig).map(key => ({
    id: key,
    nombre: categoriasConfig[key].nombre
  })).sort((a, b) => collatorEs.compare(b.nombre, a.nombre));
};

// Función para obtener todas las etiquetas de una categoría específica
export const getEtiquetasPorCategoria = (categoriaId) => {
  if (categoriasConfig[categoriaId]) {
    return [...categoriasConfig[categoriaId].etiquetas].sort((a, b) => collatorEs.compare(b, a));
  }
  return [];
};

// Función para obtener todas las etiquetas posibles
export const getAllEtiquetas = () => {
  const todasEtiquetas = [];
  Object.values(categoriasConfig).forEach(config => {
    todasEtiquetas.push(...config.etiquetas);
  });
  return [...new Set(todasEtiquetas)].sort((a, b) => collatorEs.compare(b, a)); // Usar Set para eliminar duplicados
};

// Función para validar si una categoría es válida
export const validarCategoria = (categoria) => {
  return categoriasConfig.hasOwnProperty(categoria);
};

// Función para validar si una etiqueta es válida para una categoría específica
export const validarEtiqueta = (categoria, etiqueta) => {
  if (!categoriasConfig[categoria]) {
    return false;
  }
  return categoriasConfig[categoria].etiquetas.includes(etiqueta);
};

// Función para corregir posibles errores ortográficos o variantes comunes
export const corregirCategoria = (categoria) => {
  const categoriaLower = categoria.toLowerCase();
  const mapping = {
    'videojuego': 'videojuegos',
    'videojueos': 'videojuegos',
    'deporte': 'deportes',
    'cines': 'cine',
    'television': 'cine',
    'tv': 'cine',
    'musica': 'arte', // Música se convierte a Arte
    'literatura': 'cultura', // Literatura se convierte a Cultura
    'artes': 'arte',
    'ciencias': 'ciencia',
    'geografia': 'ciencia', // Geografía se convierte a Ciencia
    'geografía': 'ciencia', // Geografía se convierte a Ciencia (con acento)
    'historia': 'cultura', // Historia se convierte a Cultura
    'matematicas': 'ciencia', // Matemáticas se convierte a Ciencia
    'matemáticas': 'ciencia', // Matemáticas se convierte a Ciencia (con acento)
    'música': 'arte', // Música se convierte a Arte (con acento)
    'premiosyeventos': 'cultura', // Premios y Eventos se convierte a Cultura
    'premios y eventos': 'cultura', // Premios y Eventos se convierte a Cultura
    // Mayúsculas iniciales
    'Videojuegos': 'videojuegos',
    'Deportes': 'deportes',
    'Cine': 'cine',
    'Arte': 'arte',
    'Ciencia': 'ciencia',
    'Cultura': 'cultura',
    'Geografía': 'ciencia',
    'Historia': 'cultura',
    'Literatura': 'cultura',
    'Matemáticas': 'ciencia',
    'Música': 'arte',
    'Premios y Eventos': 'cultura'
  };
  
  return mapping[categoria] || mapping[categoriaLower] || categoria;
};

// Función para corregir posibles errores ortográficos o variantes comunes en etiquetas
export const corregirEtiqueta = (categoria, etiqueta) => {
  if (!categoriasConfig[categoria]) {
    return etiqueta;
  }
  
  // Buscar coincidencias parciales o variantes comunes
  const etiquetas = categoriasConfig[categoria].etiquetas;
  const etiquetaLower = etiqueta.toLowerCase();
  
  // Buscar coincidencia exacta (case insensitive)
  const coincidenciaExacta = etiquetas.find(e => e.toLowerCase() === etiquetaLower);
  if (coincidenciaExacta) {
    return coincidenciaExacta;
  }
  
  // Buscar coincidencias parciales
  for (const etiquetaConfig of etiquetas) {
    if (etiquetaConfig.toLowerCase().includes(etiquetaLower) || 
        etiquetaLower.includes(etiquetaConfig.toLowerCase())) {
      return etiquetaConfig;
    }
  }
  
  return etiqueta;
};

// Función para normalizar categorías (convertir a formato estándar)
export const normalizarCategoria = (categoria) => {
  // Primero intentar corrección de errores ortográficos y conversiones
  const categoriaCorregida = corregirCategoria(categoria);
  
  // Si la categoría corregida existe en el config, devolverla
  if (categoriasConfig[categoriaCorregida]) {
    return categoriaCorregida;
  }
  
  // Si no existe, intentar con variaciones comunes (mayúsculas/minúsculas)
  const categoriaLower = categoria.toLowerCase();
  const categoriaSinAcentos = categoria
    .replace(/á/g, 'a')
    .replace(/é/g, 'e')
    .replace(/í/g, 'i')
    .replace(/ó/g, 'o')
    .replace(/ú/g, 'u')
    .replace(/ü/g, 'u')
    .toLowerCase();
  
  // Buscar en las claves del config
  for (const [clave, valor] of Object.entries(categoriasConfig)) {
    if (clave.toLowerCase() === categoriaLower ||
        clave.toLowerCase() === categoriaSinAcentos ||
        valor.nombre.toLowerCase() === categoria.toLowerCase() ||
        valor.nombre.toLowerCase() === categoriaSinAcentos) {
      return clave;
    }
  }
  
  // Si no se encuentra ninguna coincidencia, devolver la categoría corregida (que podría ser una categoría válida según corregirCategoria)
  return categoriaCorregida;
};
